import { render, staticRenderFns } from "./UIFormCart.vue?vue&type=template&id=f33a2284&"
import script from "./UIFormCart.vue?vue&type=script&lang=js&"
export * from "./UIFormCart.vue?vue&type=script&lang=js&"
import style0 from "./UIFormCart.vue?vue&type=style&index=0&id=f33a2284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports